import { render, staticRenderFns } from "./placeList.vue?vue&type=template&id=3114480a&scoped=true&"
import script from "./placeList.vue?vue&type=script&lang=js&"
export * from "./placeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3114480a",
  null
  
)

export default component.exports